module.exports = __webpack_public_path__ + "img/concurrency.fb39fb38.svg";